import { render, staticRenderFns } from "./MappingUpload.vue?vue&type=template&id=121af116&scoped=true&"
import script from "./MappingUpload.vue?vue&type=script&lang=ts&"
export * from "./MappingUpload.vue?vue&type=script&lang=ts&"
import style0 from "./MappingUpload.vue?vue&type=style&index=0&id=121af116&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121af116",
  null
  
)

export default component.exports